import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  ContentChild,
  Inject,
  Renderer2,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  EventEmitter
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CustomIcons } from '@shared/models/custom-icons';
import { MapComponent } from '@shared/components/map/components/map/map.component';
import { DOCUMENT } from '@angular/common';
import { Select, Store } from '@ngxs/store';
import { SharedCatalogState } from '@shared/state/catalog/shared-catalog.state';
import { CatalogItemFieldsVM } from '@shared/models/shared-catalog.state';
import { CatalogState } from 'app/modules/data/store/catalog/catalog.state';
import { CatalogItemValue } from 'app/modules/data/models/catalog';
import { Clipboard } from '@angular/cdk/clipboard';
import { SelectCatalogItemShared } from 'app/modules/data/store/catalog/catalog.action';
import { DataRouting } from 'app/modules/data/modules/catalog-data/models/data-routing';
import { Params } from '@angular/router';
import { MirSnackbarType } from '@shared/components/snackbar-message/model/snackbar';
import { SnackBarService } from '@shared/components/snackbar-message/services/snackbar.service';
import { takeUntil } from 'rxjs/operators';
import { getLinkToObject } from '@utils/other-utils';
import { IDestroy, TakeUntilDestroy } from '@utils/auto-unsubscribe';
import { MainPageState } from '../../store/main-page.state';

@Component({
  selector: 'app-map-carousel-wrapper',
  templateUrl: './map-carousel-wrapper.component.html',
  styleUrls: ['./map-carousel-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class MapCarouselWrapperComponent implements OnInit, OnDestroy, IDestroy {
  public componentDestroy: () => Subject<any>;
  @Input() public datasetName = 'Сезонные наборы для жителей';

  @Output() public readonly mapOpen = new Subject<boolean>();
  @Output() public readonly datasetOpen = new Subject<boolean>();
  @Output() public readonly closeCard = new EventEmitter<any>();
  @Output() public readonly sizeСonversionCard = new Subject<boolean>();
  @Output() public readonly backISelectedItem = new EventEmitter<any>();
  @ContentChild(MapComponent) public mapComponentRef: MapComponent;
  public icons = CustomIcons;
  public isFullscreen = false;
  public appealLink = `/'opendata'/${DataRouting.Appeals}`;

  public title: string;
  @Select(SharedCatalogState.fields) public itemFields$: Observable<CatalogItemFieldsVM[]>;
  @Select(CatalogState.selectCatalogItem) public itemData$: Observable<CatalogItemValue>;

  constructor(
    private snackBarService: SnackBarService,
    @Inject(DOCUMENT) private document: Document,
    private r2: Renderer2,
    private clipboard: Clipboard,
    private store: Store,
    private cdr: ChangeDetectorRef
  ) {}

  public toggleMap(isOpen: boolean | null): void {
    this.mapOpen.next(!isOpen);
  }

  public toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;

    if (!this.isFullscreen) this.toggleDataset(!this.isFullscreen);
    const container = this.mapComponentRef.map.getContainer();
    if (this.isFullscreen) {
      document.body.style.overflow = 'hidden';
      container.style.width = `${this.document.defaultView?.innerWidth}px`;
      container.style.height = `${this.document.defaultView?.innerHeight}px`;
      this.mapComponentRef.map.invalidateSize();
    } else {
      const appElements = this.document.getElementsByClassName('map');
      if (appElements.length > 0) {
        setTimeout(() => {
          container.style.width = '';
          container.style.height = '';
          const canvasElements = this.document.getElementsByTagName('canvas');
          if (canvasElements.length > 0) {
            canvasElements[0].style.width = `${appElements[0].clientWidth}px`;
            canvasElements[0].style.height = `${appElements[0].clientHeight}px`;
            canvasElements[0].width = appElements[0].clientWidth;
            canvasElements[0].height = appElements[0].clientHeight;
            document.body.style.overflow = 'visible';
            this.mapComponentRef.map.invalidateSize();
          }
        });
      }
    }
    setTimeout(() => {
      this.sizeСonversionCard.next(this.isFullscreen);
    });
  }

  public toggleDataset(isOpen: boolean | null): void {
    if (isOpen) {
      this.r2.removeClass(this.document.body, 'no-scroll');
    } else {
      this.r2.addClass(this.document.body, 'no-scroll');
    }
    this.datasetOpen.next(!isOpen);
  }

  public copyLink(): void {
    this.clipboard.copy(getLinkToObject(this.store, this.document, true));

    this.snackBarService.open(MirSnackbarType.Success, [
      {
        translate: true,
        message: 'SNACK_BAR_MESSAGE.LINK_COPY'
      }
    ]);
  }

  public appealLinkQuery(): Params {
    const catalogGlobalId = this.store.selectSnapshot(SharedCatalogState.selectCatalog).id;
    const catalogItemGlobalId = this.store.selectSnapshot(CatalogState.selectCatalogItem).global_id;
    const isBackHome = true;
    return { catalogItemGlobalId, catalogGlobalId, isBackHome };
  }

  public closeAside(): void {
    this.store.dispatch(new SelectCatalogItemShared(null));
    this.closeCard.emit();
  }

  public ngOnDestroy(): void {
    this.r2.removeClass(this.document.body, 'no-scroll');
  }

  public ngOnInit(): void {
    this.store
      .select(SharedCatalogState.selectCatalog)
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe(selectCatalog => {
        const seasonsDatasets = this.store.selectSnapshot(MainPageState.getSeasonDatasets);
        if (selectCatalog && seasonsDatasets && seasonsDatasets.length > 0) {
          const findedRes = seasonsDatasets.find(x => x.catalogId === selectCatalog.id);
          if (findedRes) {
            this.title = findedRes.text;
            this.cdr.detectChanges();
          }
        }
      });
  }
}
